import type {IssueFieldDataType} from '@github-ui/server-persisted-queries/types/IssueFieldPickerQuery'
import {colorNames, useNamedColor} from '@github-ui/use-named-color'
import {CalendarIcon, MultiSelectIcon, NumberIcon, SingleSelectIcon, TypographyIcon} from '@primer/octicons-react'

import styles from './IssueFieldLeadingVisual.module.css'
import type {IssueSingleSelectFieldPickerOptionNode} from './IssueSingleSelectFieldPicker'

export function createIssueFieldPickerItemLeadingVisual(dataType: IssueFieldDataType) {
  if (dataType === 'TEXT') {
    return TypographyIcon
  } else if (dataType === 'SINGLE_SELECT') {
    return SingleSelectIcon
  } else if (dataType === 'MULTI_SELECT') {
    return MultiSelectIcon
  } else if (dataType === 'DATE') {
    return CalendarIcon
  } else if (dataType === 'NUMBER') {
    return NumberIcon
  } else {
    return undefined
  }
}

export const createIssueSingleSelectFieldPickerItemLeadingVisual = (
  color: IssueSingleSelectFieldPickerOptionNode['color'],
) => {
  return function IssueSingleSelectFieldPickerItemLeadingVisual() {
    const effectiveColor = colorNames.find(c => c === color)
    const {bg, accent} = useNamedColor(effectiveColor)
    return <div className={styles.colorIndicator} style={{backgroundColor: bg, borderColor: accent}} />
  }
}
